import { render, staticRenderFns } from "./VendorsProfileTabs.vue?vue&type=template&id=1b335fda&scoped=true"
import script from "./VendorsProfileTabs.vue?vue&type=script&lang=js"
export * from "./VendorsProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./VendorsProfileTabs.vue?vue&type=style&index=0&id=1b335fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b335fda",
  null
  
)

export default component.exports